var React = require('react');

function DifficultyLevelProline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"id":"Rectangle","fill":"#E7993B","x":"0","y":"0","width":"44","height":"24","rx":"12","key":0}),React.createElement("circle",{"id":"Oval","stroke":"#000000","strokeWidth":"2.5","cx":"22","cy":"12","r":"10","key":1}),React.createElement("polygon",{"id":"Triangle","stroke":"#000000","strokeWidth":"1.5","fill":"#D5453B","points":"22 3 29 17 15 17","key":2})]));
}

DifficultyLevelProline.defaultProps = {"viewBox":"0 0 44 24","version":"1.1"};

module.exports = DifficultyLevelProline;

DifficultyLevelProline.default = DifficultyLevelProline;
